export default __webpack_public_path__ + "static/media/slider4.4fa091e6.jpg";